import React, { useState, useCallback } from 'react';
import Input from '../Input';
import Flexor from '../Flexor';
import Button from '../Button';
import Dropdown from '../Dropdown';
import CenteredRow from '../CenteredRow';
import { Container } from './styled.js';

function LegacyBankAccountChooser({ submit: _submit }) {
  const [routingNumber, setRoutingNumber] = useState(null);
  const [accountNumber, setAccountNumber] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const [nickName, setNickName] = useState(null);
  const [accountHolderType, setAccountHolderType] = useState(null);

  const submit = useCallback(() => {
    _submit({
      accountNumber,
      routingNumber,
      nickName,
      accountHolderType,
      accountType,
      paymentType: 'ach',
    });
  }, [_submit, accountHolderType, accountNumber, accountType, nickName, routingNumber]);
  return (
    <Container onSubmit={submit}>
      <Input
        required
        value={routingNumber}
        update={setRoutingNumber}
        label="Routing Number" />
      <Flexor flex="0 1 20px" />
      <Input
        required
        value={accountNumber}
        update={setAccountNumber}
        label="Account Number" />
      <Flexor flex="0 1 20px" />
      <Input
        required
        value={nickName}
        update={setNickName}
        label="Nick Name"
      />
      <Flexor flex="0 1 20px" />
      <CenteredRow>
        <Dropdown
          style={{ marginRight: 20 }}
          required
          options={['Individual', 'Company']}
          values={['individual', 'company']}
          update={setAccountHolderType}
          value={accountHolderType}
          label="Account Holder Type" />
        <Dropdown
          required
          options={['Checking', 'Savings', 'Ledger', 'Loan']}
          values={['checking', 'savings', 'ledger', 'loan']}
          update={setAccountType}
          value={accountType}
          label="Account Type" />
      </CenteredRow>
      <Flexor flex="0 1 20px" />
      <Button submit label="Submit" />
    </Container>
  );
}

export default LegacyBankAccountChooser;